<script setup lang="ts">
import {Yacht} from "@/models/Yacht.js";
import {computed, PropType} from "vue";
import CustomButton from "@/components/Button/Button.vue";
import defaultYacht from '@/assets/defaultYacht.png';
import {useRouter} from "vue-router";


const props = defineProps({
    yacht: {
      type: Object as PropType<Yacht>,
      required: true
    }
})

const router = useRouter();

const backgroundStyle = computed(() => {
  const imageUrl = props.yacht?.images.length > 0
      ? props.yacht?.images[0]['original']
      : props.yacht?.image_main['original'] ;

  return {
    backgroundImage: `
      linear-gradient(to bottom, rgba(16, 10, 53, 0.6), rgba(16, 10, 53, 0)),
      linear-gradient(to top, rgba(16, 10, 53, 0.4), rgba(16, 10, 53, 0)),
      url(${imageUrl})
    `
  };
});


const scrollToContent = () => {
  const el = document.getElementById('scroll-to-yachtPage');
  if (el) {
    el.scrollIntoView({ behavior: 'smooth' });
  }
}

</script>

<template>
  <div class="landingImage " :style="backgroundStyle">


    <!-- Yacht info -->
    <div class="container hero-container items-center flex flex-col h-full justify-center relative">
      <!-- Back button -->
      <div class="hidden sm:flex absolute top-32 left-0 translate-x-0 z-10">
        <CustomButton
            type="red"
            :outlined="true"
            :rounded="true"
            class="group"
            @click="router.go(-1)"
        >
          <div
              class="flex items-center gap-2"
          >

            <img
                src="@/assets/icons/Arrow_left_16x16.svg"
                alt="Back"
                class="w-5 h-5 block group-hover:hidden"
            />
            <img
                src="@/assets/icons/Arrow_left_white_16x16.svg"
                alt="Favorite"
                class="w-5 h-5 hidden group-hover:block"
            />
            <span>Go Back</span>
          </div>
        </CustomButton>


      </div>
      <div class="sm:hidden absolute top-32 left-7 -translate-x-1/2  z-10">
        <CustomButton
            type="transparent"
            :outlined="true"
            :rounded="true"
            @click="router.go(-1)"
        >
          <img
              src="@/assets/icons/Arrow_left_white_16x16.svg"
              alt="Back"
              class="w-5 h-5 block"
          />
        </CustomButton>
      </div>
      <div class="responsive-title-1 mb-6 ml-3 text-center font-thin">
        {{ yacht.name }}
      </div>
      <p class="text-center responsive-body-large font-semibold uppercase">
        {{ yacht.category }}
      </p>
    </div>

    <!-- Explore button -->
    <div
        class="mt-6 mb-2 sm:mt-10 flex flex-col gap-2 items-center text-white responsive-body-large font-bold cursor-pointer"
        @click="scrollToContent"
    >
      EXPLORE YACHT
      <img src="@/assets/icons/arrow_down.png" alt="Explore" />
    </div>
  </div>
</template>



<style scoped>
.landingImage {
  object-fit: contain;
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  height: 100vh;
  max-height: none;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: white;
  gap: 40px;
}


@media (max-width: 768px) {
  .landingImage {
    height: 100vh;
    max-height: none;
    background-position: center;
  }
}


</style>
